exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h2[data-v-f9ae4522],h3[data-v-f9ae4522],h5[data-v-f9ae4522]{margin-bottom:0}h3[data-v-f9ae4522]{cursor:pointer}.mh-400[data-v-f9ae4522]{min-height:400px}.sales-flash-table-container[data-v-f9ae4522]{margin-top:12px}.purchase-plan-table-container[data-v-f9ae4522]{position:absolute;top:60px;bottom:12px;left:16px;right:16px;overflow-y:auto}", ""]);

// exports
